import { render, staticRenderFns } from "./monCompte.vue?vue&type=template&id=6fa1e34c&"
import script from "./monCompte.vue?vue&type=script&lang=ts&"
export * from "./monCompte.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports